import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=4c16cf38&"
import script from "./add-user.vue?vue&type=script&lang=ts&"
export * from "./add-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports